<template>
  <div class="hotel-edit-accordion-8">
    <!-- TÍTULO -->
    <PmwHeading size="paragraph-80" weight="weight-light" class="form--title">
      E-mails de notificação
    </PmwHeading>

    <PmwParagraph class="form--info mb-4" size="paragraph-40">
      Configure um ou mais e-mails para acompanhamento das atividades dos
      hóspedes.
    </PmwParagraph>

    <div class="form--row">
      <!-- ACOMPANHAMENTO DE RESERVAS -->
      <Textarea
        :value="followReservations"
        :infoIcon="true"
        :withTags="true"
        :addTagOnBlur="true"
        :placeholder="
          followReservations && followReservations.length === 0
            ? 'Insira os e-mails'
            : ''
        "
        validateTags="email"
        tooltipMinWidth="219"
        infoText="Os e-mails neste campo estarão em cópia oculta em todos os e-mails de confirmação, cancelamento e expiração de reservas."
        label="Acompanhamento de Reservas"
        class="reference-tour"
        id="form--booking-tracking"
        @input="$emit('changeFollowReservations', $event)"
      />

      <!-- ACOMPANHAMENTO DA CENTRAL DE RESERVAS -->
      <Textarea
        :value="followCentral"
        :infoIcon="true"
        :withTags="true"
        :addTagOnBlur="true"
        :placeholder="
          followCentral && followCentral.length === 0 ? 'Insira os e-mails' : ''
        "
        validateTags="email"
        tooltipMinWidth="259"
        infoText="Os e-mails neste campo estarão em cópia oculta em todos os e-mails de confirmação, cancelamento e expiração de reservas. Caso nada seja preenchido, será enviado para o acompanhamento de reservas."
        label="Acompanhamento da Central de Reservas"
        class="reference-tour"
        id="form--reservation-center-follow-up"
        @input="$emit('changeFollowCentral', $event)"
      />
    </div>

    <div class="form--row">
      <!-- ACOMPANHAMENTO DE EXPERIÊNCIAS -->
      <Textarea
        :value="followExperiences"
        :infoIcon="true"
        :withTags="true"
        :addTagOnBlur="true"
        :placeholder="
          followExperiences && followExperiences.length === 0
            ? 'Insira os e-mails'
            : ''
        "
        validateTags="email"
        tooltipMinWidth="259"
        infoText="Os e-mails neste campo estarão em cópia oculta em todos os e-mails de confirmação, cancelamento e expiração de experiências. Caso nada seja preenchido, será enviado para o acompanhamento de reservas."
        label="Acompanhamento Experiências"
        class="reference-tour"
        id="form--experiences"
        @input="$emit('changeFollowExperiences', $event)"
      />

      <!-- ALERTAS -->
      <Textarea
        :value="alerts"
        :infoIcon="true"
        :withTags="true"
        :addTagOnBlur="true"
        :placeholder="alerts && alerts.length === 0 ? 'Insira os e-mails' : ''"
        validateTags="email"
        tooltipMinWidth="179"
        infoText="Os e-mails deste campo receberão alertas do sistema."
        label="Alertas"
        class="reference-tour"
        id="form--alerts"
        @input="$emit('changeAlerts', $event)"
      />
    </div>

    <div class="form--row mb-0">
      <!-- RECEBIMENTO DE PRÉ-CHECKIN -->
      <Textarea
        :value="checkin"
        :infoIcon="true"
        :withTags="true"
        :addTagOnBlur="true"
        :placeholder="
          checkin && checkin.length === 0 ? 'Insira os e-mails' : ''
        "
        validateTags="email"
        tooltipMinWidth="184"
        infoText="Os e-mails neste campo vão receber os formulários de novos pré check-ins efetuados e atualizações nos mesmos."
        label="Recebimento de Pré Check-in"
        class="reference-tour"
        id="form--pre-checkin"
        @input="$emit('changeCheckin', $event)"
      />

      <!-- REVENDEDOR -->
      <Textarea
        :value="dealer"
        :infoIcon="true"
        :withTags="true"
        :addTagOnBlur="true"
        :placeholder="dealer && dealer.length === 0 ? 'Insira os e-mails' : ''"
        validateTags="email"
        tooltipMinWidth="268"
        infoText="Os e-mails neste campo estarão em cópia oculta em todos os e-mails de confirmação, cancelamento e expiração de resevas feitas pelo Revendedor. Caso nada seja preenchido, será enviado para o acompanhamento de reservas."
        label="Revendedor"
        class="reference-tour"
        id="form--booking-monitoring"
        @input="$emit('changeDealer', $event)"
      />
    </div>
  </div>
</template>

<script>
import Textarea from '@solucoes/components-lib-tmp/src/components/elements/Textarea'
import PmwHeading from '@solucoes/components-lib-tmp/src/components/elements/PmwHeading'
import PmwParagraph from '@solucoes/components-lib-tmp/src/components/elements/PmwParagraph'

export default {
  name: 'NotificationEmails',

  components: {
    Textarea,
    PmwHeading,
    PmwParagraph
  },

  props: {
    /** Acompanhamento de Reservas */
    followReservations: {
      type: [String, Array],
      default: () => []
    },

    /** Acompanhamento da Central de Reservas */
    followCentral: {
      type: [String, Array],
      default: () => []
    },

    /** Acompanhamento Experiências */
    followExperiences: {
      type: [String, Array],
      default: () => []
    },

    /** E-mails de alerta */
    alerts: {
      type: [String, Array],
      default: () => []
    },

    /** Recebimento de Pré Check-in */
    checkin: {
      type: [String, Array],
      default: () => []
    },

    /** E-mails de Revendedores */
    dealer: {
      type: [String, Array],
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
.reference-tour {
  position: relative;
}

.pmw-form-field {
  ::v-deep {
    .pmw-form-field--label {
      font-weight: font-weight('weight-medium');
    }
    .form-field--label-wrapper {
      line-height: 21px;
      margin-bottom: 3px;
    }
    .pmw-input {
      background: $white;
    }
    .pmw-input--clear {
      z-index: 0;
    }
    .pmw-input__focus {
      border-color: $pmw-blue;
    }

    .pmw-input--field {
      background: $pmw-white;

      &:focus {
        border-color: $pmw-blue;
      }
    }
    .pmw-custom-tooltip {
      line-height: 18px;
    }
  }
}

.pmw-info-tooltip {
  ::v-deep {
    .pmw-custom-tooltip {
      display: flex;
      gap: 5px;
      color: $pmw-gray-dark;
      font-size: font-size('size-small');
      line-height: 18px;
    }
  }
  .pmw-custom-tooltip--arrow {
    display: none;
  }
}

.pmw-textarea {
  ::v-deep {
    .pmw-textarea--clear {
      display: none;
    }
    .pmw-textarea--label {
      margin-left: 0px;
    }
    .pmw-textarea--field {
      line-height: 21px;
    }
  }
}

.form {
  &--input {
    max-width: 176px;

    /** Alterar cores novas do select */
    ::v-deep {
      .pmw-select--button__caret-sort-up,
      .pmw-select--button__show {
        border-bottom-color: pmw-colors('blue-100');
      }
      .pmw-select--button:focus {
        border-color: pmw-colors('blue-100');
        border-bottom-color: pmw-colors('blue-100');
      }
      .pmw-select-options--item__hover:hover,
      .pmw-select-options--item__checked {
        background-color: pmw-colors('blue-100') !important;
      }

      .pmw-label {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  &--info {
    line-height: 18px;
    margin-bottom: 24px;
    color: $pmw-gray-dark;
  }

  &--row {
    display: flex;
    align-items: flex-start;
    flex-wrap: unset;
    gap: 22px;
    margin-bottom: 48px;
  }

  &--title {
    color: pmw-colors('blue-100');
    font-weight: font-weight('weight-medium');
    margin-bottom: 5px;
    position: relative;
  }

  &--button {
    width: auto;
  }
}
</style>
